import React from 'react'

import { PageTitle } from './common/PageTitle'
import { PageContent } from './layout/layout'
import { H3 } from './common/Typography'

const address = 'commando.numerique@fabnum.fr'

export const Contact = () => (
  <>
    <PageTitle tradId="contact" />
    <PageContent>
      <div>
        <H3 tradId="contact1" />
      </div>
      <div>
        <H3 tradId="contact2" />
      </div>
      <div>
        <H3 tradId="contact3" />
      </div>
      <div>
        <H3 tradId="contact4" />
      </div>
      <div>
        <H3 tradId="contact5" />
        {' '}
        <H3>
          <a target="blank" href={`mailto:${address}`}>{address}</a>
        </H3>
      </div>
    </PageContent>
  </>
)
